import { Fragment } from "react";
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

import useFetch from "../../../hooks/useFetch";
import { urlProductById } from "../../../helpers";
import { AddProducts } from "./AddProducts";


export const EditProducts = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { data } = useFetch(urlProductById + searchParams.get('id'));

    return (
        <Fragment>
            {data
                ? <AddProducts data={data}/>
                : <CircularProgress />
            }
        </Fragment>
    )
}